// removed by extract-text-webpack-plugin
module.exports = {"colors":"\"../../../styles/variables.css\"","primary":"#56CCF2","textDefault":"#808080","container":"_2bQwhgWUTpYSsT8yGu_gZI","quiz":"hVjpV2sB-VW1CuMDMgrDm","checkBox":"_1wHhCKMQ8YyypJKr4aWc4b","checkBoxWrapper":"_3XAvqHFrpVe0BJJYcL10Np","answerDescription":"_309oc5lVXDpdNUIIpOisyX","navButtons":"FP3bvNgqVDHqQXev6ImXO","wrong":"_10oTBidFkCG29-uJh_pr_Z","textLabel":"_2mI1PbiHfBKiVVbTC5TAo5","box":"_25TRrCyxmSEVKf8QCuUTVc","correct":"_3k5z2Th_tWBzQ5w3BZYaK_","label":"_37bfGt9e3IEUz8yR5cyh8w"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Module/components/QuizStep.mod.css
// module id = 1694
// module chunks = 0